import { render, staticRenderFns } from "./EditStaff.vue?vue&type=template&id=2ee7df2e&scoped=true&"
import script from "./EditStaff.vue?vue&type=script&lang=js&"
export * from "./EditStaff.vue?vue&type=script&lang=js&"
import style0 from "./EditStaff.vue?vue&type=style&index=0&id=2ee7df2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ee7df2e",
  null
  
)

export default component.exports